import type { InputProps } from "@chakra-ui/react";
import { Input, forwardRef } from "@chakra-ui/react";
import React from "react";
import type { FieldError } from "react-hook-form";
import { stripColon } from "@/helpers/string";
import { FormGroup } from "./FormGroup";

interface Props extends InputProps {
  label: string;
  error?: FieldError | string;
  isError?: boolean;
}

export const FormInput = forwardRef<Props, "input">(
  ({ label, error, isError, ...props }, ref) => {
    const strippedLabel = stripColon(label);
    const errorColor = "primary-light";
    const isFinalError = error || isError;

    return (
      <FormGroup
        label={label}
        error={error}
        isError={isError}
      >
        <Input
          ref={ref}
          placeholder={strippedLabel}
          color={isFinalError ? errorColor : undefined}
          borderColor={isFinalError ? errorColor : undefined}
          _placeholder={{
            color: isFinalError ? errorColor : undefined,
          }}
          {...props}
        />
      </FormGroup>
    );
  },
);
